/* 開放日詳情 */
import React, { useState, useEffect, useRef } from 'react';
import { Helmet, UserState, useSelector } from 'umi';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { ActivityIndicator } from 'antd-mobile'; // 添加导入
import { formatDateTime2 } from '@/utils/dateutils';
import { commonPostRequest } from '@/utils/apiUtils';
import { useIntl } from '@@/plugin-locale/localeExports';
import styles from './css/Detail.module.less';

// 定义 dataObj 和 applyObj 的类型接口
interface DataObjType {
  id: string;
  appNo: string;
  applicantName: string;
  applicantNameCn: string;
  applicantLastNameCn: string;
  applicantFirstNameCn: string;
  applicantNameEn: string;
  applicantLastNameEn: string;
  applicantFirstNameEn: string;
  applicantGender: number;
  spouseName: string;
  applicantEmail: string;
  applicantCellphone: string;
  applicantAreano: string;
  applicantAddress: string;
  submitTime: string;
  flowStatus: number;
  appResult: string;
  auditRemark: string;
  cancelStatus: number;
  cancelWay: number;
  cancelReason: string;
}

const fetchApplyDetail = async (params?: Record<string, unknown>): Promise<DataObjType[]> => {
  return commonPostRequest<DataObjType[]>('/api/adoptappli/applydetail', params);
};


const OpendayDetail: React.FC = () => {
  const intl = useIntl();
  // 在组件内部添加引用
  const history = useHistory();
  // 獲取參數 ID
  const urlParams = new URLSearchParams(window.location.search);
  const itemId = urlParams.get('id');
  const { profile } = useSelector(({ user }: { user: UserState }) => user);
  const [loading, setLoading] = useState<boolean>(true);


  const scrollRef = useRef<HTMLDivElement>(null);
  const [dataObj, setDataObj] = useState<DataObjType>({} as DataObjType);
  // 請求數據
  useEffect(() => {
    if (!profile || !profile.euid) {
      setLoading(true);
      return undefined;
    }
    const params = {
      id: itemId,
      euid: profile.euid,
    };
    // 请求数据
    fetchApplyDetail(params)
      .then((data) => {
        if (data != null && data.id) {
          setDataObj(data);
        } else {
          window.location.href = '/foster-apply-list?platform=personal';
        }
        setLoading(false); // 数据获取完成后关闭loading
      })
      .catch((error) => {
        console.error('获取數據失败:', error);
        setLoading(false); // 出错时也关闭loading
      });
  }, [profile.euid]);

  const getStatusText = (flowStatus: number, cancelStatus?: number): string => {
    // 如果取消状态为1，直接显示已取消
    if (cancelStatus === 1) {
      return intl.formatMessage({ id: '已取消' });
    }
    switch (flowStatus) {
      case 0:
        return intl.formatMessage({ id: '草稿' });
      case 1:
        return intl.formatMessage({ id: '待評估' });
      case 2:
        return intl.formatMessage({ id: '評估完成' });
      default:
        return intl.formatMessage({ id: '未知狀態' });
    }
  };

  // 注釋
  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: '申請成為寄養父母' })}</title>
      </Helmet>

      <div className={clsx(styles.baseRoot)}>
        {loading ? (
          <div className={styles.loadingContainer}>
            <ActivityIndicator toast text="加载中..." />
          </div>
        ) : (
          <>
            <div className={styles.main} ref={scrollRef}>
              <div className={clsx(styles.contentDiv)}>
                <p>
                  <span className={styles.pSpan1}>{intl.formatMessage({ id: '申請編號' })}</span>
                  {' '}
                  <span className={styles.pSpan2}>{dataObj.appNo}</span>
                </p>
                <p>
                  <span className={styles.pSpan1}>{intl.formatMessage({ id: '申請人姓名' })}</span>
                  {' '}
                  <span className={styles.pSpan2}>{dataObj.applicantName}</span>
                </p>
                <p>
                  <span className={styles.pSpan1}>{intl.formatMessage({ id: '配偶姓名' })}</span>
                  {' '}
                  <span className={styles.pSpan2}>{dataObj.spouseName}</span>
                </p>
                <p>
                  <span className={styles.pSpan1}>{intl.formatMessage({ id: '聯繫電話' })}</span>
                  {' '}
                  <span className={styles.pSpan2}>{dataObj.applicantAreano}-{dataObj.applicantCellphone}</span>
                </p>
                <p>
                  <span className={styles.pSpan1}>{intl.formatMessage({ id: '地址' })}</span>
                  {' '}
                  <span className={styles.pSpan2}>{dataObj.applicantAddress}</span>
                </p>
                <p>
                  <span className={styles.pSpan1}>{intl.formatMessage({ id: '申請提交時間' })}</span>
                  {' '}
                  <span className={styles.pSpan2}>
                    {dataObj.submitTime ? formatDateTime2(dataObj.submitTime) : dataObj.submitTime}
                  </span>
                </p>
                <p>
                  <span className={styles.pSpan1}>{intl.formatMessage({ id: '狀態' })}</span>
                  {' '}
                  <span className={styles.pSpan2}>
                    {getStatusText(dataObj.flowStatus, dataObj.cancelStatus)}
                  </span>
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default OpendayDetail;
